import { render } from "./CountrySvg.vue?vue&type=template&id=b501524c"
const script = {}
script.render = render

export default script